/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: npm run preprocess:generate-python-v2
 * Generated at: 2025-12-13T03:38:54.857Z
 * 
 * Index of Python training sections
 * Use lazy imports to load section data on demand
 */

export interface SectionMetadata {
  id: string;
  title: string;
  description: string;
  introducedChars: string[];
  isPrerequisite: boolean;
  prerequisites: string[];
  classCount: number;
  fileName: string;
}

export const pythonSectionsMetadata: SectionMetadata[] = [
  {
    "id": "python-variables-basic",
    "title": "Variables & Assignment",
    "description": "Variable names and assignment operator",
    "introducedChars": [
      "_",
      "="
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 6,
    "fileName": "section-1-python-variables-basic.ts"
  },
  {
    "id": "python-functions",
    "title": "Functions",
    "description": "Function calls and definitions",
    "introducedChars": [
      "(",
      ")",
      ",",
      ":"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 6,
    "fileName": "section-2-python-functions.ts"
  },
  {
    "id": "python-object-oriented",
    "title": "Object-Oriented",
    "description": "Attribute access and method calls",
    "introducedChars": [
      "."
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 3,
    "fileName": "section-3-python-object-oriented.ts"
  },
  {
    "id": "python-lists",
    "title": "Lists",
    "description": "List operations and indexing",
    "introducedChars": [
      "[",
      "]"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 4,
    "fileName": "section-4-python-lists.ts"
  },
  {
    "id": "python-dictionaries",
    "title": "Dictionaries",
    "description": "Dictionary operations and f-strings",
    "introducedChars": [
      "{",
      "}"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 4,
    "fileName": "section-5-python-dictionaries.ts"
  },
  {
    "id": "python-strings",
    "title": "Strings",
    "description": "String literals and f-strings",
    "introducedChars": [
      "\"",
      "'"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 6,
    "fileName": "section-6-python-strings.ts"
  },
  {
    "id": "python-math-operators",
    "title": "Math Operators",
    "description": "Arithmetic operations",
    "introducedChars": [
      "+",
      "-",
      "*",
      "/"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 6,
    "fileName": "section-7-python-math-operators.ts"
  },
  {
    "id": "python-comparisons",
    "title": "Comparisons",
    "description": "Comparison operators",
    "introducedChars": [
      "<",
      ">",
      "!"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 6,
    "fileName": "section-8-python-comparisons.ts"
  },
  {
    "id": "python-comments",
    "title": "Comments",
    "description": "Code comments and documentation",
    "introducedChars": [
      "#"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 4,
    "fileName": "section-9-python-comments.ts"
  },
  {
    "id": "python-advanced",
    "title": "Advanced Operators",
    "description": "Special operators and patterns",
    "introducedChars": [
      "%",
      "@",
      "|",
      "&",
      "\\"
    ],
    "isPrerequisite": false,
    "prerequisites": [
      "basics:all"
    ],
    "classCount": 9,
    "fileName": "section-10-python-advanced.ts"
  }
];

/**
 * Lazy-load a section by ID
 * @param sectionId The section ID to load
 * @returns Promise resolving to the section data
 */
export async function loadPythonSection(sectionId: string) {
  // Use explicit imports to avoid Vite dynamic import warnings
  switch (sectionId) {
    case 'python-variables-basic':
      return (await import('./section-1-python-variables-basic')).section;
    case 'python-functions':
      return (await import('./section-2-python-functions')).section;
    case 'python-object-oriented':
      return (await import('./section-3-python-object-oriented')).section;
    case 'python-lists':
      return (await import('./section-4-python-lists')).section;
    case 'python-dictionaries':
      return (await import('./section-5-python-dictionaries')).section;
    case 'python-strings':
      return (await import('./section-6-python-strings')).section;
    case 'python-math-operators':
      return (await import('./section-7-python-math-operators')).section;
    case 'python-comparisons':
      return (await import('./section-8-python-comparisons')).section;
    case 'python-comments':
      return (await import('./section-9-python-comments')).section;
    case 'python-advanced':
      return (await import('./section-10-python-advanced')).section;
    default:
      throw new Error(`Section not found: ${sectionId}`);
  }
}
